import { Spacing } from '../../../enums/spacing'
import { pxToNumber } from '../../../utils/pxToNumber'

export const MODULE_LAYOUT_BOTTOM_SPACE = `${pxToNumber(Spacing.S40) * 2}px`
